export default __webpack_public_path__ + "static/media/GY.dd391a9f.ico";